import type { CefrLevel } from '@/types/common'

export interface UserSettings {
  nativeLanguage: string
  uiLanguage: string
  theme: 'light' | 'dark'
  dailyGoalNewWords: number
  dailyGoalReviews: number
  dailyGoalArticles: number
  dailyGoalPractice: number
  notificationsEnabled: boolean
  timezone: string
  targetEnglishLevel: CefrLevel
  sessionDurationMinutes: number
  includeQuickChallenge: boolean
  preferredTags: string[]
  onboardingCompleted: boolean
  defaultReviewMode: 'CLASSIC' | 'REVERSE' | 'FILL_BLANK' | 'MULTIPLE_CHOICE'
}

export interface UpdateSettingsRequest {
  nativeLanguage?: string
  uiLanguage?: string
  theme?: 'light' | 'dark'
  dailyGoalNewWords?: number
  dailyGoalReviews?: number
  dailyGoalArticles?: number
  dailyGoalPractice?: number
  notificationsEnabled?: boolean
  timezone?: string
  targetEnglishLevel?: CefrLevel
  sessionDurationMinutes?: number
  includeQuickChallenge?: boolean
  preferredTags?: string[]
  onboardingCompleted?: boolean
  defaultReviewMode?: 'CLASSIC' | 'REVERSE' | 'FILL_BLANK' | 'MULTIPLE_CHOICE'
}

export interface ChangePasswordRequest {
  currentPassword: string
  newPassword: string
}

export interface DeleteAccountRequest {
  password: string
  confirmation: string
}

export const NATIVE_LANGUAGE_OPTIONS = [
  { code: 'ru', label: 'Russian' },
  { code: 'uk', label: 'Ukrainian' },
  { code: 'pl', label: 'Polish' },
] as const

const NATIVE_LANGUAGE_OPTION_CODES = new Set(
  NATIVE_LANGUAGE_OPTIONS.map((option) => option.code),
)

/** Options for native-language selects; keeps the current value visible if it is no longer offered. */
export function nativeLanguageSelectOptions(currentCode?: string) {
  if (!currentCode || NATIVE_LANGUAGE_OPTION_CODES.has(currentCode)) {
    return NATIVE_LANGUAGE_OPTIONS
  }
  return [{ code: currentCode, label: currentCode }, ...NATIVE_LANGUAGE_OPTIONS]
}

export const CEFR_LEVEL_OPTIONS: Array<{ value: CefrLevel; label: string }> = [
  { value: 'A1', label: 'A1 — Beginner' },
  { value: 'A2', label: 'A2 — Elementary' },
  { value: 'B1', label: 'B1 — Intermediate' },
  { value: 'B2', label: 'B2 — Upper intermediate' },
  { value: 'C1', label: 'C1 — Advanced' },
  { value: 'C2', label: 'C2 — Proficient' },
]
